import React, { useContext } from 'react';
import {
  Box, HStack, Icon, Text,
} from '@gluestack-ui/themed';
import { Info } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

import {
  WaitingBedMuteButton,
  WaitingBedMuteContext,
} from '@/student/module/components/lobby/WaitingLoungeAtmosphereChrome';

/** InfoBar-styled strip so a dry run is never mistaken for a graded exam session. */
export function OralExamPracticeBanner() {
  const { t } = useTranslation();
  const mute = useContext(WaitingBedMuteContext);
  const showMute = Boolean(mute?.show);

  return (
    <HStack
      alignItems="center"
      px="$4"
      py="$2"
      bg="$statusInfoSubtle"
      borderBottomWidth={1}
      borderBottomColor="$statusInfo"
      testID="oral-exam-practice-banner"
    >
      <HStack flex={1} alignItems="center" justifyContent="center" space="sm">
        <Icon as={Info} size="sm" color="$statusInfo" />
        <Text size="sm" fontWeight="semibold" color="$textOnInfoSubtle" textAlign="center">
          {t('oralExam.practice.banner', { defaultValue: 'This is a dry run — not graded' })}
        </Text>
      </HStack>
      {showMute && mute ? (
        <Box ml="$3" flexShrink={0}>
          <WaitingBedMuteButton bedMuted={mute.bedMuted} onToggle={mute.onToggle} />
        </Box>
      ) : null}
    </HStack>
  );
}
